<template>
  <div class="riepilogo-trasferte-mobile mobile_customize col-xs-24">

    <transition name="fade">
      <ricerca v-show="showSearchPanel" @closeRicerca="closeSearch" @cerca="cerca" @loadingOff="setLoading(false)"
        :tipoRicerca="'Trasferte_Aut_form'">
      </ricerca>

    </transition>

    <div class="header-tab row row-custom">
      <div class="col-4 no-padding icon-search">
        <el-button @click="openSearch">
          <icon name="riv-filter" scale="1.4"></icon>
        </el-button>
      </div>
      <div class="mobile-title col-16 no-padding">{{ $t('trasferte.label.title') }}</div>
      <div class="col-4 no-padding">
        <!--<div class="add" @click="opTrasferte('3')"> 
          <icon name="riv-autorizza" scale="2" flip="horizontal" class="pointer"></icon>
        </div>-->
      </div>
    </div>

    <el-table :data="listaTrasferte" row-class-name="single riga-hover double" row-key="idTrasferta"
      @row-click="dettTrasferta" :empty-text="$t('trasferte.msg.noData')" v-loading="loading" class="el-table_mobile">

      <el-table-column width="30" header-align="center" align="center">

        <template slot-scope="scope" slot="header">
          <div class="icon-title" :key="scope.length">
            <el-popover placement="top" trigger="click">
              <div>
                <div>
                  <icon :name="getStatoIcon('0')" class="status-saved" scale="1.2"></icon>
                  <span>{{ $t('status.0') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('1')" class="status-send" scale="1.2"></icon>
                  <span>{{ $t('status.1') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('2')" class="status-rejected" scale="1.2"></icon>
                  <span>{{ $t('status.2') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('3')" class="status-approved" scale="1.2"></icon>
                  <span>{{ $t('status.3') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('4')" class="status-send" scale="1.2"></icon>
                  <span>{{ $t('status.4') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('4')" class="status-approved" scale="1.2"></icon>
                  <span>{{ $t('status.3') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('7')" class="status-delete" scale="1.2"></icon>
                  <span>{{ $t('status.7') }}</span>
                </div>
              </div>
              <span slot="reference">
                <icon class="pointer" name="riv-help" scale="1"></icon>
              </span>
            </el-popover>

          </div>
        </template>

        <template slot-scope="scope">
          <div class="name-wrapper">
            <el-tooltip class="item" effect="dark" :content="$t(getStatoDes(scope.row))" placement="top-start">
              <icon :name="getStatoIcon(scope.row.statoAvanz)" :class="getStatoClass(scope.row)" scale="1.2"></icon>
            </el-tooltip>
          </div>
        </template>

      </el-table-column>

      <el-table-column header-align="center" align="center" :label="$t('trasferte.label.periodo')" width="80"
        class-name="sfondino">

        <template slot-scope="scope">
          <div class="name-wrapper">
            <span class="block">{{ scope.row.dataDal | formattaData }}</span>
            <span class="block">{{ formatPeriodo2(scope.row) }}</span>
          </div>
        </template>

      </el-table-column>
      <el-table-column header-align="center" align="center" :label="$t('trasferte.label.employee')">

        <template slot-scope="scope">
          <!--<div class="name-wrapper truncate-overflow">
            {{ scope.row.nomeDip }} {{ scope.row.cognomeDip }}
          </div>-->
          <div class="name-wrapper">
            <span class="block">{{ scope.row.nomeDip }}</span>
            <span class="block">{{ scope.row.cognomeDip }}</span>
          </div>
        </template>

      </el-table-column>
      <el-table-column header-align="center" align="center" :label="$t('trasferte.label.destinazione')">

        <template slot-scope="scope">
          <div class="name-wrapper">
            <span class="block">{{ scope.row.desDest === '' ? scope.row.desMan : scope.row.desDest }}</span>
            <span class="block">{{ scope.row.desCli }}</span>
          </div>
        </template>

      </el-table-column>

      <el-table-column width="30">

        <template slot-scope="scope" v-if="scope.row.statoAvanz === '1'">
          <div class="name-wrapper" :key="scope.length" @click.stop.prevent>
            <el-tooltip placement="left" popper-class="popover-mobile" effect="light">
              <template slot="content">
                <div @click="opTrasferte('3', scope.row)" v-if="scope.row.statoAvanz === '1'">
                  <span>{{ $t('btn.approva') }}</span>
                </div>
              </template>

              <icon class="pointer action" name="riv-more" scale="1.5"></icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

    </el-table>

    <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" background layout="prev, pager, next"
      :total="nrItems" :page-size="pag_for" @current-change="changePage">
    </el-pagination>

  </div>
</template>
<script>
import Ricerca from './RicercaMobile.vue'
import { bus } from '../Bus.js'
import moment from 'moment'

export default {
  components: { Ricerca },
  name: 'RiepilogoAutorizzazioni',
  i18n: {
    messages: {
      it_IT: {
        trasferte: {
          label: {
            title: 'Trasferta',
            periodo: 'Periodo',
            dataIn: 'Data Inizio',
            dataFin: 'Data Fine',
            employee: 'Dipendente',
            destinazione: 'Destinazione',
            soc: 'Per Conto della Società'
          },
          msg: {
            info: 'Avviso!',
            abort: 'Operazione Annullata',
            noData: 'Nessun Documento trovato',
            selectAllApp: 'Seleziona tutti i documenti da Approvare',
            confApp: 'Sei sicuro di voler Approvare tutte le trasferte selezionate?',
            noDocsSel: 'Nessun documento selezionato'
          }
        }
      },
      fr_FR: {
        trasferte: {
          label: {
            title: 'Deplacement',
            periodo: 'Date du-au',
            dataIn: 'Date du',
            dataFin: 'Date au',
            employee: 'Employé',
            destinazione: 'Destination',
            soc: 'pour le compte de'
          },
          msg: {
            info: 'Info!',
            abort: 'Opération annulée',
            noData: 'Aucun document trouvé',
            selectAllApp: 'Sélectionner tous les documents à annuler',
            confApp: 'Êtes-vous sur d\'approuver toutes les demandes de déplacement selectionnées?',
            noDocsSel: 'Aucun document selectionné',
          }
        }
      },
      es_ES: {
        trasferte: {
          label: {
            title: 'Viaje',
            periodo: 'Fecha desde-hasta',
            dataIn: 'Dia salida',
            dataFin: 'Dia regreso',
            employee: 'Empleado',
            destinazione: 'Destino',
            soc: 'Por cuenta de la sociedad'
          },
          msg: {
            info: '¡Aviso!',
            abort: 'Operación cancelada',
            noData: 'Sin informacion',
            selectAllApp: 'Seleccionar todos los documentos pendientes de aprobación',
            confApp: '¿Seguro que quieres aprobar todos los viajes seleccionados?',
            noDocsSel: 'Ningún documento seleccionado',
          }
        }
      },
      de_DE: {
        trasferte: {
          label: {
            title: 'Dienstreise',
            periodo: 'Datum von-bis',
            dataIn: 'Reisebeginn',
            dataFin: 'Reiseende',
            employee: 'Mitarbeiter',
            destinazione: 'Reiseziel',
            soc: 'auf Kosten der Firma'
          },
          msg: {
            info: 'Beachten!',
            abort: 'Operation abgebroche',
            noData: 'Kein Dokument gefunden',
            selectAllApp: 'Wählen Sie alle zu genehmigenden Dokumente aus',
            confApp: 'Möchten Sie wirklich alle ausgewählten Reisen genehmigen?',
            noDocsSel: 'Keine Dokumente ausgewählt'
          }
        }
      },
      en_GB: {
        trasferte: {}
      }
    }
  },
  data() {
    return {
      visibleInfo: false,
      loading: false,
      showSearchPanel: false,
      showModalDettaglio: false,
      form: {
        dataIn: '',
        dataFin: '',
        statoAvanz: '',
        destinazione: '',
        ccDipendente: '',
        daGestire: true
      },
      listaTrasferte: [],
      trasferta: [],
      dettaglioTrasferta: [],
      nrPages: 0,
      nrItems: 0,
      currentPage: 1,
      pag_for: 8,
      ordine: 'DD'
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    }
  },
  mounted: function () {
    this.$emit('setShowNuovo', true)
    this.initialize()
  },
  methods: {
    initialize: function () {
      this.$nextTick(() => {
        if (sessionStorage.hasOwnProperty('Trasferte_Aut_form')) {
          this.$set(this, 'form', JSON.parse(sessionStorage.getItem('Trasferte_Aut_form')))
          //this.ricerca(false)
        }
        this.ricerca(false)
      })
    },
    closeSearch: function () {
      this.$emit('showScroll')
      this.showSearchPanel = false
    },
    openSearch: function () {
      this.showSearchPanel = true
      this.$emit('hideScroll')
    },
    cerca: function (form) {
      let formRicerca = JSON.parse(form)
      this.$set(this, 'form', formRicerca)
      this.currentPage = 1
      this.ricerca(false)
    },
    ricerca: function (flagIfChangeSort) {
      this.loading = true
      if (flagIfChangeSort === true) {
        this.$set(this, 'form', JSON.parse(sessionStorage.getItem('Trasferte_Aut_form')))
        this.currentPage = 1
      }
      let numStatiAvanz = ''
      let statoAvanz = ''
      if (this.form.statoAvanz == '' || this.form.statoAvanz == 'all') {
        statoAvanz = ''
        numStatiAvanz = "0";
      } else {
        statoAvanz = '[{"id":"' + this.form.statoAvanz + '"}]';
        numStatiAvanz = "1"
      }
      sessionStorage.setItem('Trasferte_Aut_form', JSON.stringify(this.form))
      this.$http.get('trasferte/' + this.$store.state.country + '/trasferte', {
        params: {
          vista: 'R',
          pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: this.currentPage,
          pag_for: this.pag_for,
          pag_order: this.ordine,
          dataDal: (this.form.dataDal === '' || this.form.dataDal === undefined) ? '' : moment(this.form.dataDal, 'YYYY-MM-DD').format('YYYYMMDD'),
          dataAl: (this.form.dataAl === '' || this.form.dataAl === undefined) ? '' : moment(this.form.dataAl, 'YYYY-MM-DD').format('YYYYMMDD'),
          statoAvanz: statoAvanz,
          numStatiAvanz: numStatiAvanz,
          destinazione: this.form.destinazione,
          ccDipendente: this.form.ccDipendente,
          daGestire: this.form.daGestire === undefined || this.form.daGestire ? 'si' : 'no',
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.listaTrasferte = response.body.data.map(function (obj) {
              obj.checkConvalida = false
              return obj
            })
            // this.listaTrasferte = response.body.data
            if (this.currentPage === 1) {
              this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
            }
          } else {
            this.$set(this, 'listaTrasferte', [])
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)
          }
          this.closeSearch()
          setTimeout(() => {
            this.loading = false
          }, 500)
        })
    },
    changePage: function (page) {
      this.currentPage = page
      this.ricerca(false)
    },
    /*  Viene richiamata quando l'utente clicca sulle frecce di ordinamento della tabella. Setta il codice di ordinamento corrispondente
     *  e richiama il servizio di ricerca con questo codice
     */
    sortChange: function ({ column, prop, order }) {
      if (prop === 'dataIn') {
        if (order === 'ascending') {
          this.ordine = 'DA'
        } else if (order === 'descending') {
          this.ordine = 'DD'
        }
      } else if (prop === 'dataFin') {
        if (order === 'ascending') {
          this.ordine = 'AA'
        } else if (order === 'descending') {
          this.ordine = 'AD'
        }
      } else if (prop === 'dip') {
        if (order === 'ascending') {
          this.ordine = 'CA'
        } else if (order === 'descending') {
          this.ordine = 'CD'
        }
      } else {
        this.ordine = 'DD'
      }
      this.ricerca(true)
    },
    dettTrasferta: function (row, event, column) {
      this.$router.push({ name: 'AutorizzaTrasferta', params: { id: row.idTrasferta } })
    },
    getStatoDes: function (record) {
      switch (record.statoAvanz) {
        case '4':
          if ((record.statoAlloggio === undefined || record.statoAlloggio === "" || record.statoAlloggio === "3") &&
            (record.statoMensa === undefined || record.statoMensa === "" || record.statoMensa === "3") &&
            (record.statoBiglietti === undefined || record.statoBiglietti === "" || record.statoBiglietti === "3") &&
            (record.statoTrasporti === undefined || record.statoTrasporti === "" || record.statoTrasporti === "3") &&
            (record.statoAutoAz === undefined || record.statoAutoAz === "" || record.statoAutoAz === "3")) {
            return 'status.3'
          } else {
            return 'status.' + record.statoAvanz
          }
        default:
          return 'status.' + record.statoAvanz
          break;
      }
    },
    getStatoIcon: function (stato) {
      switch (stato) {
        case '0':
          return 'riv-save2'
        case '1':
        case '2':
        case '3':
          return 'riv-user'
        case '4':
          return 'riv-alloggio'
        case '7':
          return 'elm-chiudi'
        default:
          return ''
      }
    },
    getStatoClass: function (record) {
      switch (record.statoAvanz) {
        case '0':
          return 'status-saved'
        case '1':
          return "status-send"
        case '2':
          return "status-rejected"
        case '3':
          return "status-approved"
        case '4':
          if ((record.statoAlloggio === undefined || record.statoAlloggio === "" || record.statoAlloggio === "3") &&
            (record.statoMensa === undefined || record.statoMensa === "" || record.statoMensa === "3") &&
            (record.statoBiglietti === undefined || record.statoBiglietti === "" || record.statoBiglietti === "3") &&
            (record.statoTrasporti === undefined || record.statoTrasporti === "" || record.statoTrasporti === "3") &&
            (record.statoAutoAz === undefined || record.statoAutoAz === "" || record.statoAutoAz === "3")) {
            return "status-approved"
          } else {
            return "status-send"
          }
        case '7':
          return 'status-delete'
          break;
        default:
          return ''
          break;
      }
    },
    checkConvalida: function (event) {
      for (var i = 0; i < this.listaTrasferte.length; i++) {
        if (this.listaTrasferte[i].statoAvanz === '1') this.listaTrasferte[i].checkConvalida = event
      }
    },
    opTrasferte: function (statoAvanz, row) {
      let _this = this;

      let message = this.$i18n.t('trasferte.msg.confApp')
      let btnOK = this.$i18n.t('btn.approva')

      this.$confirm(message, 'Info', {
        confirmButtonText: btnOK,
        cancelButtonText: this.$i18n.t('btn.annulla'),
        type: 'info',
        callback: function (action) {
          if (action === 'confirm') {

            let counter = 1
            let righe = []
            let riga = {
              idTrasferta: row.idTrasferta,
              operazione: "*UPD",
              statoAvanz: statoAvanz,
              ccDipendente: row.ccDipendente
            }
            righe.push(riga)

            _this.loading = true
            let obj = {
              numRec: counter,
              trasferte: righe
            }
            _this.$http.post('trasferte/' + _this.$store.state.country + '/approvazione', obj).then(response => {
              if (response.body.rc === 0) {
                _this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'success',
                  duration: process.env.duration
                })
                _this.ricerca()
              } else {
                _this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'warning',
                  duration: process.env.duration
                })
              }
              _this.loading = false
            })
          } else {
            _this.$message({
              showClose: true,
              message: _this.$i18n.t('trasferte.msg.abort'),
              type: 'info',
              duration: process.env.duration
            })
          }
        }
      });
    },
    formatPeriodo2: function(row) {
      if (row.tipoTrasferta === 'GIO' && row.dataAl) {
        return (row.dataAl.substr(6, 2) + '/' + row.dataAl.substr(4, 2) + '/' + row.dataAl.substr(0, 4))
      } else  if (row.tipoTrasferta === 'ORE') {
        return '(' + row.oraDal + ' - ' + row.oraAl + ')'
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/mobile_customize.less";
@import "../../assets/less/el-table_mobile.less";
@import "../../assets/less/el-form_mobile.less";

.riepilogo-trasferte-mobile {
  padding: 0;

  .header-tab {
    height: 40px;
    // border-bottom: 1px solid #007c74;
    text-align: center;
    margin-bottom: 20px;

    .icon-search {
      line-height: 40px;

      .el-button {
        height: 40px;
        width: 40px;
        border-radius: 0px;
        //margin-top: 12px;
        //margin-left: 10px;
        padding: 0px;
        color: @greenRiva;
        float: left;
        border: 1px solid @greenRiva;
      }

      .el-button:hover {
        background-color: @white;
      }
    }

    .add {
      line-height: 40px;
      // position: fixed;
      // right: 20px;
      // bottom: 20px;
      float: right;
      color: #FF791A;
      margin-right: 10px;
      margin-left: 10px;
    }
  }

  .action {
    height: 20px;
    line-height: 20px;

    span {
      float: right;
      .set-font(@size: 14px,
        @color: @grayDark,
        @weight: bold,
        @family: "os-regular"
      );
      text-transform: capitalize;
      padding-right: 15px;
    }
  }

}

.el-message-box-mobile {
  width: 98%;
}

.status-send {
  color: @orangeMedium
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}

.popover-mobile {
  line-height: 50px;
  .set-font(@size: 18px, @color: @grayTesto, @family: "os-semibold")
}

.el-form-body {
  .el-table_mobile {
    height: 100%;
    min-height: 150px;
  }
}

.el-message-box {
  width: 96% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TrasferteMobile/RiepilogoAutorizzazioniMobile.vue